import { css } from '@emotion/react';

import { Spacing } from 'chatie-design-system';

import Frame from './Frame';

const skeletonCSS = css`
  padding: ${Spacing.small}px ${Spacing.medium}px;
  display: grid;
  box-sizing: content-box;
  height: 42px;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: ${Spacing.medium}px;

  div:nth-of-type(1) {
    grid-column: 1 / 4;
    grid-row: 1;
  }

  div:nth-of-type(2) {
    grid-column: 1 / 2;
    grid-row: 2;
  }

  div:nth-of-type(3) {
    grid-column: 4;
    grid-row: 2;
  }
`;

const EpisodeSkeleton = () => {
  return (
    <div css={skeletonCSS}>
      <Frame />
      <Frame />
      <Frame />
    </div>
  );
};

export default EpisodeSkeleton;
